import React from 'react';
import { Box } from '@mui/material';

export const NoteStatus = ({ hectaresToAdd, LangFile }) => (
  <Box
    sx={{
      fontWeight: 300,
    }}
  >
    <Box
      className="valid"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {LangFile.PolygonDrawing.area}: <span>{hectaresToAdd} ha</span>
    </Box>
  </Box>
);
